import { useModal } from './useModal';
import { Modal } from './ModalComponents';

const DeleteConfirmModal = ({ onClose }: { onClose: () => void }) => {
  return (
    <>
      <Modal.Header title="Delete Item" />
      <Modal.Content>
        <p className="text-gray-600">
          Are you sure you want to delete this item? This action cannot be undone.
        </p>
      </Modal.Content>
      <Modal.Actions>
        <button
          onClick={onClose}
          className="px-4 py-2 text-gray-700 bg-white border border-gray-300 rounded hover:bg-gray-50"
        >
          Cancel
        </button>
        <button
          onClick={() => {
            /* Delete logic here */ onClose();
          }}
          className="px-4 py-2 text-white bg-red-600 rounded hover:bg-red-700"
        >
          Delete
        </button>
      </Modal.Actions>
    </>
  );
};

export const ModalExample = () => {
  const { openModal } = useModal();

  const handleDeleteClick = () => {
    // Pass the component factory to the modal
    openModal((props) => <DeleteConfirmModal {...props} />);
  };

  return (
    <div className="p-10">
      <h1 className="text-2xl font-bold mb-4">Modal System Example</h1>
      <button
        onClick={handleDeleteClick}
        className="px-6 py-3 text-white bg-blue-600 rounded hover:bg-blue-700"
      >
        Open Delete Modal
      </button>
    </div>
  );
};
